import { Box, Text, Grid, useToast, Button } from '@chakra-ui/react'
import { useNavigate, useParams } from "react-router-dom"
import { animation } from '../../BackData/animation.js'



export const AnimationPage = ({ side, setSide }) => {
    const { id } = useParams()
    const toast = useToast();
    const navigate = useNavigate()

    const copyToClipboard = (ele) => {
        navigator.clipboard.writeText(ele);
        toast({ title: 'Code Copied', status: 'success', duration: 4000, isClosable: true, position: 'top' })
    }

    return (
        <Box w={'95%'} m={side ? '1.4cm auto 1cm auto' : '0.5cm auto'}>
            {!side && <Box display={'flex'} alignItems={'center'} fontSize={'25px'} fontWeight={'bold'} m={'0cm auto 1cm auto'}>
                <Text ml={'10px'} cursor={'pointer'} onClick={() => setSide(!side)}>|||</Text>
                <Text ml={'15px'} cursor={'pointer'} onClick={() => navigate('/')}>ArtKorner</Text>
            </Box>}

            <Box onClick={() => navigate('/Animation')} cursor={'pointer'} m={'0 10px'} mb={'-20px'} fontWeight={'bold'} letterSpacing={'0.7px'} _hover={{color:'grey'}} transition={'0.3s ease'}>← Back</Box>
            <Box display={'flex'} flexDirection={['column', 'column', 'row']} justifyContent={'space-between'} alignItems={'center'} gap={'10px'} mb={'1cm'}>
                <Box m={'auto'} display={'block'}>
                    <style>{animation[id].CSS}</style>
                    <Box  w={'200px'} h={'200px'} display={'flex'} justifyContent={'center'} alignItems={'center'} dangerouslySetInnerHTML={{ __html: animation[id].HTML }} />
                </Box>

                <Box w={['95%', '90%', '40%']} p={'20px 10px'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'}>
                    <Box bg={'whiteAlpha.900'} h={'150px'} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'} overflow={'scroll'} m={'10px auto'} p={'10px'}>
                        <Text>{animation[id].HTML_ORG}</Text>
                    </Box>
                    <Box><Button onClick={()=>copyToClipboard(animation[id].HTML_ORG)} w={'100%'} p={'10px'} bg={'yellow.400'} color={'white'}>Copy</Button></Box>
                    <Box bg={'whiteAlpha.900'} h={'150px'} boxShadow={'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px'} overflow={'scroll'} m={'10px auto'} p={'10px'}>
                        <Text>{animation[id].CSS}</Text>
                    </Box>
                    <Box><Button onClick={()=>copyToClipboard(animation[id].CSS)} w={'100%'} p={'10px'} bg={'yellow.400'} color={'white'}>Copy</Button></Box>
                </Box>
            </Box>
        
        </Box>
    )
}